import React, {useEffect, useState} from "react"

import VScroll from "../../scrolling/custom-v-scroll/v-scroll"
import {ColorPalette} from "../../../fields3/color-coding/color-coding"
import {PROJECT_COLOR_OPTIONS} from "../../../fields3/generic/color/color"
import ApiProject from "../../../gd/api/project"
import ProjectSession from "../../../model2/project/project-session";

type Props = {
    options?        : any[] | null
    project         : ProjectSession
    hidePopover     : callback
    onChange        : callback
}

// const debug = "ProjectColorSelector"
const debug = false

export default function ProjectColorSelector(props: Props) {

    const sessionProject : ProjectSession = props.project

    const [color, setColor] = useState<number|undefined>()

    const treeHasChildren = !props.project.isTag && props.project.treeHasChildren

    useEffect(() => {
        setColor(sessionProject.color)
    }, [sessionProject.color, sessionProject.projectIcon, sessionProject.systemType])

    const onColorSelect = (color:number) => {
        sessionProject.color = color
        setColor(color)
        props.onChange(color)
    }

    const onApplyToChildren = ()=>{

        if (!treeHasChildren) {
            return
        }

        props.hidePopover()

        gd.modals.confirm.genericText("Are you sure ?","Are you sure you want to apply the current color to all the child folders?",
            async ()=>{
                await ApiProject.applyColorToChildren(props.project.id).promise()
                gd.modal.hide()
            }
        )
    }

    const hasChildrenClasses = Classes("flex-row-left-center", {
        "ui5-link-small"            : treeHasChildren,
        "ui5-txt-disabled-small"    : !treeHasChildren
    })

    const hasChildrenIconClasses = Classes("i5-color", "m-r-5", {
        "ui5-ico-13 link"               : treeHasChildren,
        "ui5-txt-disabled-small fs-13"  : !treeHasChildren
    })

    return (
        <VScroll containerClass="color-with-icon ui5-popover-menu max-h-500">
            <div className="flex-column-left-top">
                <div className="flex-row-left-center ui5-txt-not-important ui5-txt-bold h-36 p-l-10">Change color</div>

                <div className="ui5-popover-selector color-picker w-320 p-t-10">
                    {_.map(PROJECT_COLOR_OPTIONS, (option: Option) => {

                        const classes = Classes("ui5-color-picker", {
                            'is-selected': option.value === color
                        })

                        const style: style = {
                            backgroundColor: gd.skin.colors.mainColor({
                                colorNumber: option.value,
                                corePalette: ColorPalette.CORE
                            })
                        }

                        return (
                            <div key={option.value}
                                 className={classes}
                                 style={style}
                                 onClick={() => onColorSelect(option.value)}/>
                        )
                    })}
                </div>

                <div className="flex-row-right-center p-r-20 w-100-percent border-box m-b-10">
                    <div className={hasChildrenClasses} onClick={onApplyToChildren}>
                        <div className={hasChildrenIconClasses}/>
                        Apply to subfolders
                    </div>
                </div>
            </div>
        </VScroll>
    )
}

